import SportsMenuTabList from './SportsMenuTabList';
import { SportsMenuTabListProps, SportsMenuTabListValueProps } from './types';

export type { SportsMenuTabListProps, SportsMenuTabListValueProps };
export default SportsMenuTabList;
